import React from 'react';
import { Card } from './ui/card';
import * as LucideIcons from 'lucide-react';
import { services, cloudPartners } from '../mockData';

const CloudServices = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-emerald-50/30 via-white to-blue-50/20 relative overflow-hidden">
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-blue-200/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Illustration */}
          <div className="relative order-2 lg:order-1">
            <div className="relative">
              <img
                src="https://images.pexels.com/photos/5480781/pexels-photo-5480781.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Cloud Services"
                className="w-full h-auto rounded-2xl shadow-xl"
              />
              <div className="absolute -top-4 -left-4 w-full h-full border-4 border-blue-500/20 rounded-2xl -z-10"></div>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-8 order-1 lg:order-2">
            <div>
              <div className="inline-block">
                <div className="h-1 w-16 bg-gradient-to-r from-blue-500 to-emerald-500 rounded-full mb-4"></div>
              </div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Managed Cloud & Security Services
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-8">
                TYJ Group Provides You with Complete Set of Reliable Services
              </p>
            </div>

            {/* Services Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {services.cloud.map((service) => {
                const Icon = LucideIcons[service.icon];
                return (
                  <Card
                    key={service.id}
                    className="p-4 hover:shadow-lg transition-all duration-300 border-l-4 border-l-blue-500 hover:border-l-blue-600 hover:scale-105 cursor-pointer group bg-white"
                  >
                    <div className="flex items-center space-x-3">
                      <div className="p-2 bg-blue-100 rounded-lg group-hover:bg-blue-500 transition-colors">
                        <Icon className="w-5 h-5 text-blue-600 group-hover:text-white transition-colors" />
                      </div>
                      <span className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                        {service.name}
                      </span>
                    </div>
                  </Card>
                );
              })}
            </div>

            {/* Cloud Partners */}
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-6">
                TYJ Group partners with global cloud service providers
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {cloudPartners.map((partner) => (
                  <div
                    key={partner.id}
                    className="bg-white p-6 rounded-lg shadow-sm hover:shadow-lg transition-all border border-gray-100 group cursor-pointer"
                  >
                    <div className="w-full h-16 flex items-center justify-center bg-gradient-to-br from-blue-50 to-emerald-50 rounded-lg group-hover:from-blue-100 group-hover:to-emerald-100 transition-all">
                      <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-emerald-600 bg-clip-text text-transparent">
                        {partner.initials}
                      </span>
                    </div>
                    <p className="text-xs text-center text-gray-600 mt-3 font-medium">
                      {partner.name}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CloudServices;
